import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { Market } from '@entity/market';
import { MarketService } from '@service/market.service';

export const MarketsResolve: ResolveFn<Market[]> = () => {
  return inject(MarketService).getMarkets();
};
